// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"86a95684bf2d9ecf173b43731fe8cb0eb04c1022"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/docs/86a95684bf2d9ecf173b43731fe8cb0eb04c1022";import { initClient } from '@rbx/sentry';

initClient({
  environment: process.env.environment,
  release: process.env.sentryRelease,
  enabled: process.env.NODE_ENV !== 'development',
  dsn: 'https://7bae6472ac4c465db9271bd29a391e69@o293668.ingest.sentry.io/4504732139061248',
  allowUrls: [
    /https?:\/\/create\.roblox\.com/,
    /https?:\/\/create\.sitetest(1|2|3)\.robloxlabs\.com/,
  ],
  ignoreErrors: [
    // NOTE(2025/04/18,jcountryman): Remove API Errors from Sentry
    'The request failed and the interceptors did not return an alternative response',
    'Event `CustomEvent` (type=unhandledrejection) captured as promise rejection',
    'Response from',
  ],
});
